const DialogNames = {
  ADJUST: "adjust",
  IMPORT: "import",
  UPLOAD: "upload",
  CUT_PLAN_APPROVAL: "cut_plan_approval",
  MANUAL_MARKER: "manual_marker",
  SPLICE_POINTS: "splice_points"
};

export default DialogNames;
